import { Stack, Text, TextField } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { Immocom } from '../../specifique/immocom';

export class EUITextField extends Component {

    static defaultProps = {
        afficherNbCaracteresRestants: true,
        disabled: false,
        label: undefined,
        maxLength: undefined,
        onBlur: undefined,
        onChange: undefined, // (event, newValue) => null
        onDelayedChange: undefined, // (event, newValue) => null
        onFocus: undefined,
        removeMultipleSpaces: false,
        removeSpecialCharacters: false,
        value: "",
    };

    static defaultState = {
        hasFocus: false,
        pendingValue: null, // Tampon utilisé pour la validation des données
    };

    constructor() {
        super();
        this.state = { ...EUITextField.defaultState };
        this.delayedChange = window.setTimeout(null);
    };

    _onBlur = (event) => {
        const { onBlur } = this.props;
        this.setState({ hasFocus: false });
        if (typeof onBlur === "function") {
            const newValue = event.target.value;
            onBlur(event, newValue);
        }
    };

    _onChange = (event, newValue) => {

        const { onChange, onDelayedChange, removeMultipleSpaces, removeSpecialCharacters } = this.props;

        if (removeMultipleSpaces)
            newValue = newValue.replace(/  +/g, " ");

        if (removeSpecialCharacters)
            newValue = newValue.replace(/[^a-zA-Z0-9'\-àâäéèêëïîôöùûüÿçÀÂÄÉÈÊËÏÎÔÖÙÛÜŸÇ ]+/g, "");

        if (typeof onChange === "function")
            onChange(event, newValue);

        if (typeof onDelayedChange === "function") {
            this.setState({ pendingValue: newValue });
            window.clearTimeout(this.delayedChange);
            const handler = () => {
                onDelayedChange(null, newValue);
                this.setState({ pendingValue: null });
            }
            this.delayedChange = window.setTimeout(handler, 750);
        }
        else this.setState({ pendingValue: null });

    };

    _onFocus = (event) => {
        const { onFocus } = this.props;
        this.setState({ hasFocus: true });
        if (typeof onFocus === "function") onFocus(event);
    };

    _onRenderLabel = (props, defaultRender) => {

        const { afficherNbCaracteresRestants, disabled, label, maxLength, value } = this.props;
        const { hasFocus, pendingValue } = this.state;
        const defaultLabel = defaultRender(props);

        if (hasFocus && afficherNbCaracteresRestants && !!label && !disabled && !!maxLength && Number.isInteger(maxLength)) {
            const nbCarRestants = Immocom.fiche().getNbCarRestants(pendingValue !== null ? pendingValue : value, maxLength);
            return <Stack horizontal horizontalAlign="space-between" verticalAlign="end">
                {defaultLabel}
                <Text variant="small">{`${nbCarRestants}/${maxLength}`}</Text>
            </Stack>
        }
        else return defaultLabel;

    };

    render = () => {

        const { value } = this.props;
        const { pendingValue } = this.state;

        return <TextField
            {...this.props}
            onRenderLabel={this._onRenderLabel}
            onBlur={this._onBlur}
            onChange={this._onChange}
            onFocus={this._onFocus}
            value={pendingValue !== null ? pendingValue : value || ""}
        />;

    };

}